import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import Box from "ui/atom/Box";


export default function Title({ title, subtitle, center = false }) {
	const theme = useTheme();

	const style = {
		root: {
			alignSelf: center ? "center" : "flex-start",
			textAlign: center ? "center" : "justify"
		},
		subtitle: {
			pl: theme.spacing(1.25),
			borderLeft: center ? "none" : `2px solid ${theme.palette.text.secondary}`,
			color: "text.secondary",
			maxWidth: { xs: "300px", sm: "100%" }
		}
	};

	return (
		<Box.Column sx={style.root}>
			<Typography variant="h1" fontSize={32}>{title}</Typography>
			<Typography variant="body1" fontWeight={center ? 400 : 700} sx={style.subtitle}>{subtitle}</Typography>
		</Box.Column>
	);
};